import { render } from "./enrolmentStep1.vue?vue&type=template&id=6e22f27f&scoped=true"
import script from "./enrolmentStep1.vue?vue&type=script&lang=js"
export * from "./enrolmentStep1.vue?vue&type=script&lang=js"

import "./enrolmentStep1.vue?vue&type=style&index=0&id=6e22f27f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e22f27f"]])

export default __exports__